export default __webpack_public_path__ + "static/media/broken.9987ae1f.png";